import type { ExcluirCentroResponse } from '@triade/contracts';
import { Button } from '@/components/ui/button';
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { MOTIVO_EXCLUSAO_TEXTO } from './mensagens';

export interface ResultadoExclusaoProps {
  nome: string;
  resultado: ExcluirCentroResponse;
  onFechar: () => void;
}

/** Resultado do POST :id/excluir: excluido de vez, ou desativado com os motivos (a API nao apaga o que tem uso). */
export function ResultadoExclusaoDialog({ nome, resultado, onFechar }: ResultadoExclusaoProps) {
  const excluido = resultado.resultado === 'EXCLUIDO';
  const motivos = resultado.motivos.map((m) => MOTIVO_EXCLUSAO_TEXTO[m]);
  return (
    <Dialog open onOpenChange={(aberto) => !aberto && onFechar()}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{excluido ? `${nome} foi excluído` : `${nome} foi desativado`}</DialogTitle>
          <DialogDescription>
            {excluido
              ? 'Não tinha filhos, CPM, etapas de ficha, lotes nem origem importada, então saiu do cadastro.'
              : `Não pode ser excluído porque ${motivos.join(', ')}. Nada foi apagado: o centro e o que aponta para ele continuam, e ele não recebe CPM novo.`}
          </DialogDescription>
        </DialogHeader>
        {!excluido && <p className="text-small text-ink-body">Centros desativados (o centro e a subárvore, se for sintético): {resultado.desativados}.</p>}
        <DialogFooter>
          <Button type="button" onClick={onFechar}>
            Entendi
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
